import React from 'react';
import styled from 'styled-components';

import AntdInput from 'antd/lib/input';
import AntdSelect from 'antd/lib/select';

// import { getProductsUrl } from '../../helpers/getStoreUrl';

import Types from '../../modules/types';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import { createChangeLogSection } from '../../components/FieldChangeLog';

import tests from '../../helpers/tests';

const InputAligned = styled(AntdInput)`
  text-align: ${({ align }) => align || 'left'};
  width: 100%;
`;

const Select = styled(AntdSelect)`
  width: 100%;
`;

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
}];

export const fieldId = ['FieldSelect', {
  name: '_id',
  label: 'Language',
  search: true,
  choices: Types.LANGUAGES.map(({ code, name }) => ({
    label: name,
    value: code,
  })),
  rules: [['validation.isRequired']],
  disabled: [tests.activityIsNotCreate],
  virtual: [tests.activityIsNotCreate],
}];

export const fieldDirection = ['FieldRadio', {
  name: 'direction',
  label: 'Direction',
  initialValue: 'LTR',
  choices: [{
    value: 'LTR',
    label: 'Left To Right',
  }, {
    value: 'RTL',
    label: 'Right To Left',
  }],
  block: true,
}];

export const fieldsDictionary = Object.keys(Types.DICTIONARY_OBJECT)
.reduce(
  (agr, key) => {
    const rows = Types.DICTIONARY_OBJECT[key]
    .map(({ key: itemKey, label }) => ({
      name: itemKey,
      key: itemKey,
      label,
    }))
    .sort(({ key: a }, { key: b }) => (a > b ? 1 : a < b ? -1 : 0))
    .sort((a, b) => {
      let aHigher = 1;
      let bHigher = -1;
      if (key === 'email') {
        aHigher = -1;
        bHigher = 1;
      }
      return (a.label > b.label ? aHigher : a.label < b.label ? bHigher : 0);
    })
    agr[key] = ['FieldTable', {
      label: 'Dictionary',
      // label: null,
      name: 'dictionary',
      table: {
        // showHeader: true,
        showHeader: false,
        rowKey: 'key',
        size: 'small',
        // style: { marginTop: '6px' },
      },
      prepareValueForInput: (value = {}) => rows.map(
        (row) => ({
          key: row.key,
          name: row.label || row.name,
          value: value[row.key],
        }),
      ),
      prepareValueForForm: value => value.reduce(
        (agg, { key: keyItem, value: rowValue }) => {
          agg[keyItem] = rowValue;
          return agg;
        },
        {},
      ),
      columns: [
        {
          key: 'key',
          title: 'Key',
          getLabel: (value, _props) => (
            <span
              title={value.key}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: value.name }}
            />
          ),
          width: '40%',
        },
        {
          key: 'name',
          title: 'Translation',
          width: '100px',
          fields: [{
            name: 'value',
            props: {
              size: 'small',
              align: 'left',
              placeholder: 'Translation',
            },
            getProps: (field, value, props) => {
              const direction = props.form.getFieldValue('direction');
              return { align: direction === 'RTL' ? 'right' : 'left' };
            },
            render: (inputProps, props) => {
              const { value } = props;
              if (value.key === 'checkoutComLocalization') {
                return (
                  <Select
                    {...inputProps}
                  >
                    {
                      Types.CHECKOUT_COM_LOCALIZATIONS.map(choice => (
                        // eslint-disable-next-line max-len
                        <AntdSelect.Option key={choice.value} value={choice.value}>
                          {choice.label}
                        </AntdSelect.Option>
                      ))
                    }
                  </Select>
                );
              }
              return (
                <InputAligned {...inputProps} />
              );
            },
          }],
        },
      ],
    }];
    return agr;
  },
  {},
);

export const fieldChangeLog = createChangeLogSection({
  changeLogConfig: {
    getWhereConditions: props => ({
      store: { EQ: null },
      'target.type': 'Language',
      'target.subject': props.data._id,
    }),
    skipColumns: {
      store: true,
      realm: true,
      target: true,
    },
  },
});

export const CREATE = [
  fieldName,
  getFilterWithCol(fieldId, 12),
  getFilterWithCol(fieldDirection, 12),
];

export const ADMIN = [
  fieldName,
  getFilterWithCol(fieldId, 12),
  getFilterWithCol([
    fieldDirection[0],
    {
      ...fieldDirection[1],
      disabled: [tests.viewerIsNotThehiveRsAdminNorAbdul],
    },
  ], 12),
  ...fieldChangeLog,
];
